import { DocumentWorkflowTemplateVisibleIn } from '@dealstack/shared/lib/generated';
import { formatEnumValue } from './formatEnumValue.ts';

// The KYC audiences are configured under KYC Requirements, not here. Already-configured
// templates still render them, so they stay removable.
const HIDDEN_VISIBLE_IN: DocumentWorkflowTemplateVisibleIn[] = [
	DocumentWorkflowTemplateVisibleIn.KYC_INDIVIDUAL,
	DocumentWorkflowTemplateVisibleIn.KYC_VEHICLE,
];

export const getVisibleInOptions = (
	selected: DocumentWorkflowTemplateVisibleIn[]
): { value: DocumentWorkflowTemplateVisibleIn; label: string }[] =>
	Object.values(DocumentWorkflowTemplateVisibleIn)
		.filter((value) => !HIDDEN_VISIBLE_IN.includes(value) || selected.includes(value))
		.map((value) => ({ value, label: formatEnumValue(value) }));
